import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { deleteProcedure } from 'utils/urls';
import { ErrorModal } from 'types/modalTypes';

export async function removeProcedure({
  accountId,
  procedureIds,
}: TVariables): Promise<TResult> {
  const response = await fetch(deleteProcedure(accountId), {
    method: 'DELETE',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(procedureIds),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  procedureIds: Array<number>;
};

type TSnapshot = unknown;

function useDeleteProcedure(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const { accountId } = params;
    const fetchResponse = await removeProcedure(params);
    if (fetchResponse.Data) {
      queryClient.invalidateQueries(['get_archived_procedures', accountId], {
        refetchInactive: true,
      });
    } else if (fetchResponse.Errors) throw fetchResponse;
    return fetchResponse;
  });
}

export { useDeleteProcedure };
